import React,{Fragment} from 'react'
import CardSliderProducer from '../cardslider/CardSliderProducer'
import {Link} from 'react-router-dom'
import soccer from '../layout/Team/images/soccer.png'
import nynfcLogo from './../../img/nynfc_logo.svg'
// import OwlCarousel from 'react-owl-carousel';




const PlayersLanding = () => {
    return(
        <Fragment>
            <div className="container-fluid players-landing-container-main text-center">
                <div className="players-landing-img-h1">
                    <img src={soccer} alt="" className="players-landing-img" />
                        <h1 className="player-landing-h1">View our Players</h1>
                        <img src={nynfcLogo} alt="" className="players-landing-nynfc-img" />
                </div>
            </div>
                <div className="players-landing-container text-center" >
                    {/* <h1 className="players-landing-h1s">Forward</h1> */}
                    <CardSliderProducer />
                </div>
        </Fragment>
    )
}

export default PlayersLanding


